export const meta: BlockMeta = {
  title: "Image",
  tags: ["subpage"],
}

import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { GridBreakout } from "@components/site/GridBreakout"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks, useInlineEditableValue } from "eddev/blocks"

export default defineBlock("content/image", (props) => {
  const [caption, setCaption] = useInlineEditableValue("caption", "Example caption")
  const showCaption = env.admin || (caption && caption !== "Example caption")

  return (
    <GridBreakout
      amount={props.style === "wide" ? 1 : 0}
      className={cn("block-image w-full flex flex-col gap-4 mt-5 mb-5")}
    >
      <div className="w-full">
        {props.image ? (
          <ResponsiveImage {...props.image} className="w-full h-full" objectFit="contain" objectPosition="center" />
        ) : (
          env.admin && (
            <div className="w-full h-0 pt-[60%] bg-grey1 border border-dashed border-black relative">
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">Image</div>
            </div>
          )
        )}
      </div>
      {showCaption && (
        <div className="image-caption w-full text-grey6">
          <EditableText
            as="span"
            className="type-label-m"
            store="caption"
            defaultValue="Example caption"
            placeholder="Example caption"
          />
        </div>
      )}
    </GridBreakout>
  )
})
